import React, { useState, forwardRef,  useEffect } from 'react';
import { NavLink, useParams} from 'react-router-dom';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import DatosCabezaFamilia from './../Caracterizacion/DatosCabezaFamilia';
import DataTable from 'react-data-table-component';
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import AddressGenerator from '../Caracterizacion/Personas/AdressGenerator';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import MenuCaracterizacion from '../Caracterizacion/Componentes/MenuCaracterizacion';
import { FaCalendar, FaEraser, FaMap } from 'react-icons/fa';

registerLocale('es', es);
setDefaultLocale('es');

export default function Autonomia(){
    const { token, rol } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const { idCabezaFamilia } = useParams();
    const [show, setShow] = useState(false);
    const [showDireccionNegocio, setShowDireccionNegocio] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const [sexos, setSexos] = useState([]);
    const [zonas, setZonas] = useState([]);
    const [tiposEntorno, setTiposEntorno] = useState([]);
    const [parentescos, setParentescos] = useState([]);
    const [autonomiasectores, setAutonomiasectores] = useState([]);
    const [autonomiadondefunciona, setAutonomiadondefunciona] = useState([]);
    const [tiposInversion, settiposInversion] = useState([]);
    const [autonomiaNoTieneCredito, setAutonomiaNoTieneCredito] = useState([]);
    const [autonomiaHorarioCapacitacion, setAutonomiaHorarioCapacitacion] = useState([]);
    const { control, handleSubmit, register, setValue, watch, getValues, reset, formState: { errors }} = useForm();
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
      const columnsautonomiaformacion = [
        {
            name: 'Acciones',
            cell: row => (
            <div>
                <button type="button" onClick={() => BorrarFormacion(row)} 
                        style={{backgroundColor: 'red'}} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Borrar">
                    <FaEraser size={20} color="white" />
                </button>
                
            </div>
            ),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Cursos empresariales realizados', selector: row => row.redTipo, sortable: true, width:'10%' },
        { name: 'Cursos t&eacute;cnicos realizados', selector: row => row.redParentesco, sortable: true, width: '15%'},
        { name: 'Otros cursos realizados', selector: row => row.redNombre, sortable: true, width: '15%' },
        { name: 'Necesidades en capacitaci&oacute;n empresarial', selector: row => row.redTelefonos, sortable: true, width: '10%' },
        { name: 'Necesidades en capacitaci&oacute;n t&eacute;cnica<', selector: row => row.redDireccion, sortable: true, width: '10%' }
    ];
    const { AutonomiaFormacionSeleccionada, append, remove } = useFieldArray({
    control,
    name: 'AutonomiaFormacionSeleccionada'
    });
    function BorrarFormacion (row){
        remove(getValues('AutonomiaFormacionSeleccionada').indexOf(row));
    };
    function setDireccion(data){
        setValue('direccion', data);
    }
    const AgregarFormacion = async () => {
        append({
            redTipo: getValues('cursosEmpresariales'), 
            redParentesco: getValues('cursosTecnicos'), 
            redNombre : getValues('cursosOtros'),
            redTelefonos: getValues('necesidadCapEmpresarial'),
            redDireccion: getValues('necesidadCapTecnica')
        });
        setValue('cursosEmpresariales', '');
        setValue('cursosTecnicos', '');
        setValue('cursosOtros', '');
        setValue('necesidadCapEmpresarial', '');
        setValue('necesidadCapTecnica', '');
    };
    function setDireccionNegocio(data){
        setValue('direccionNegocio', data);
    }
    const showModal = () => setShow(true);
    const hideModal = () => setShow(false);
    const showModalDireccionNegocio = () => setShowDireccionNegocio(true);
    const hideModalDireccionNegocio = () => setShowDireccionNegocio(false);
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const CustomInput = forwardRef(({ value, onClick }, ref) => (
        <div className="custom-input" onClick={onClick} ref={ref}>
            <input value={value} readOnly className='widthCalendar'/>
            <FaCalendar size={20} color="black" />
        </div>
    ));
    useEffect(() => {
        let now = new Date();
        const fetchData = async () => {
            let url = '/retorno/autonomia/crearformautonomiaeconomica';
            let obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: rol }
            try {
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                setCabezaFamiliaDatos(result.cabezafamilia);
                setSexos(result.sexos);
                setZonas(result.tiposzonas);
                setTiposEntorno(result.tiposentorno);
                setParentescos(result.parentescos);
                setAutonomiasectores(result.sectores);
                setAutonomiadondefunciona(result.autonomiadondefunciona);
                settiposInversion(result.tiposinversion);
                setAutonomiaHorarioCapacitacion(result.horarioscapacitacion);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
        };
        fetchData();
    }, []);
    const onSubmit = async (data) => {
        const values = getValues();
        setCargando(true);
        let url;
        url = '/retorno/autonomia/registrarautonomiaeconomica';
        try {
            const response = await apiService.post(url, values, token);
            if(response.status === 200){
                Mensaje('Guardar autonomia economica', JSON.stringify(response.data));
                reset({
                    atencionesfields: []
                  });
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
        
    };
    
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Autonom&iacute;a economica</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} >Grupo familiar</NavLink></li>}
                        <li className="breadcrumb-item active"> Autonom&iacute;a economica</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia}></MenuCaracterizacion>
                    <div className="row">
                    {/* left column */}
                    <div className="col-md-12">
                        <div className="card card-info">
                        <div className="card-header">
                            <h3 className="card-title">Autonom&iacute;a economica</h3>
                        </div>
                        {/* /.card-header */}
                        {/* form start */}
                        <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                            <div className="card-body">
                                <DatosCabezaFamilia datos={CabezaFamiliaDatos}></DatosCabezaFamilia>
                                <input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>Persona a Cargo del Negocio</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label>¿La unidad de negocio est&aacute; cargo de una persona que no es el jefe o jefa de hogar?</label>
                                            <select {...register('personaaCargo', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.personaaCargo && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                        <label>Nombre encargado/a del negocio</label>
                                            <input {...register('nombreEncargado')}  className="form-control" placeholder=""/>
                                            {errors.nombreEncargado && <p style={{color: 'red'}}>Digite nombre</p>}
                                        </div>
                                    </div>
                                </div> 
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label>	No. De la c&eacute;dula de ciudadan&iacute;a:</label>
                                            <input {...register('cedula')}  className="form-control" placeholder=""/>
                                            {errors.cedula && <p style={{color: 'red'}}>Digite numero</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label>Sexo</label>
                                            <select {...register('sexo', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {sexos.map((item) => (
                                                <option key={item.sexNombre} value={item.sexNombre}>
                                                    {item.sexNombre}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.sexo && <p style={{color: 'red'}}>Seleccione sexo</p>}
                                        </div>
                                    </div>
                                </div> 
                                <div className='row'>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Fecha de nacimiento</label>
                                            <Controller
                                                
                                                control={control}
                                                name="fechaNacimiento"
                                                render={({ field }) => (
                                                    <DatePicker
                                                    placeholderText="fecha"
                                                    onChange={(date) => field.onChange(date)}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    selected={field.value}
                                                    customInput={<CustomInput />}
                                                    locale="es"
                                                    dateFormat="yyyy-MM-dd"
                                                    maxDate={new Date()}
                                                    />
                                                )}
                                            />
                                            {errors.fechaNacimiento && <p style={{color: 'red'}}>Digite fecha</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Zona</label>
                                            <select {...register('tipoZonaId', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {zonas.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.tipTipozona}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.tipoZonaId && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Nombre zona:</label>
                                            <input {...register('nombreZona')}  className="form-control" placeholder=""/>
                                            {errors.nombreZona && <p style={{color: 'red'}}>Digite nombre</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>	Tipo de entorno</label>
                                            <select {...register('tipoEntornoId', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {tiposEntorno.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.tipTipoentorno}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.tipoEntornoId && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Nombre tipo de entorno:</label>
                                            <input {...register('nombreTipoEntorno')}  className="form-control" placeholder=""/>
                                            {errors.nombreTipoEntorno && <p style={{color: 'red'}}>Digite nombre</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-7">
                                        <div className="form-group" >
                                            <label>Direcci&oacute;n:</label>
                                            <div className="input-group my-colorpicker2">
                                                <input {...register('direccion', { required: true })}  className="form-control" placeholder="Dirección"/>
                                                <div className="input-group-append">
                                                    <button type="button" className="input-group-text" onClick={showModal}>
                                                        <FaMap color="black" /> Generar dir. 
                                                    </button>
                                                </div>
                                            </div>
                                            {errors.direccion && <p style={{color: 'red'}}>Digite direccion</p>}
                                            
                                        </div>
                                        
                                        <AddressGenerator show={show} handleClose={hideModal} setDireccion={setDireccion}>
                                        </AddressGenerator>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Tel&eacute;fono 1</label>
                                            <input {...register('telefono1')}  className="form-control" placeholder=""/>
                                            {errors.telefono1 && <p style={{color: 'red'}}>Digite campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Tel&eacute;fono 2</label>
                                            <input {...register('telefono2')}  className="form-control" placeholder=""/>
                                            {errors.telefono2 && <p style={{color: 'red'}}>Digite campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Celular</label>
                                            <input {...register('celular')}  className="form-control" placeholder=""/>
                                            {errors.celular && <p style={{color: 'red'}}>Digite campo</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Relaci&oacute;n con el jefe del hogar</label>
                                            <select {...register('parentescoId', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {parentescos.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.parParentesco}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.parentescoId && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Incluido/a en la declaracion</label>
                                            <select {...register('incluidoDeclaracion', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.incluidoDeclaracion && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>Informaci&oacute;n general sobre el negocio</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label>Nombre del negocio</label>
                                            <input {...register('nombreNegocio')}  className="form-control" placeholder=""/>
                                            {errors.nombreNegocio && <p style={{color: 'red'}}>Digite nombre</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label>Tiempo de funcionamiento</label>
                                            <input {...register('tiempoFuncionamiento')}  className="form-control" placeholder="0"/>
                                            {errors.tiempoFuncionamiento && <p style={{color: 'red'}}>Digite tiempo en meses</p>}
                                        </div>
                                    </div>
                                </div> 
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="actividadEconomica">Actividad economica (descripci&oacute;n)</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('actividadEconomica', { required: true })}
                                                placeholder="Observaciones actividad economica"
                                            />
                                            {errors.actividadEconomica && <p style={{color: 'red'}}>Favor digite Observaciones</p>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>	Sector econ&oacute;mico</label>
                                            <select {...register('sectorId', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {autonomiasectores.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.secSector}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.sectorId && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Donde funciona negocio</label>
                                            <select {...register('dondeFuncionaId', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {autonomiadondefunciona.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.donDondefunciona}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.dondeFuncionaId && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label>	Direcci&oacute;n/ubicaci&oacute;n del negocio si es diferente a casa</label>
                                            <div className="input-group mb-3">
                                                <input {...register('direccionNegocio', { required: true })}  className="form-control" placeholder="Dirección negocio"/>
                                                <div className="input-group-append">
                                                    <button type="button" className="input-group-text" onClick={showModalDireccionNegocio}>
                                                        <FaMap color="black" /> Generar dir. 
                                                    </button>
                                                </div>
                                            </div>
                                            {errors.direccionNegocio && <p style={{color: 'red'}}>Digite direccion negocio</p>}
                                            
                                        </div>
                                        
                                        <AddressGenerator show={showDireccionNegocio} handleClose={hideModalDireccionNegocio} setDireccion={setDireccionNegocio}>
                                        </AddressGenerator>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label>Recibio apoyo de generaci&oacute;n de ingresos por parte de gobierno local o nacional	n</label>
                                            <select {...register('recibioApoyo', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.recibioApoyo && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Entidad/programa</label>
                                            <input {...register('entidadPrograma')}  className="form-control" placeholder=""/>
                                            {errors.entidadPrograma && <p style={{color: 'red'}}>Digite entidad</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Año</label>
                                            <input type='number' min="1984" max="2050" {...register('anio')}  className="form-control" placeholder="0"/>
                                            {errors.ano && <p style={{color: 'red'}}>Digite año</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Cuanto recibi&oacute;</label>
                                            <input type='number' {...register('cuantoRecibio')}  className="form-control" placeholder="0"/>
                                            {errors.cuantoRecibio && <p style={{color: 'red'}}>Digite cuanto</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>Formaci&oacute;n y capacitaci&oacute;n</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label>Cursos empresariales realizados</label>
                                            <input {...register('cursosEmpresariales')}  className="form-control" placeholder=""/>
                                            {errors.cursosEmpresariales && <p style={{color: 'red'}}>Digite campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label>Cursos t&eacute;cnicos realizados</label>
                                            <input {...register('cursosTecnicos')}  className="form-control" placeholder=""/>
                                            {errors.cursosTecnicos && <p style={{color: 'red'}}>Digite campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label>Otros cursos realizados</label>
                                            <input {...register('cursosOtros')}  className="form-control" placeholder=""/>
                                            {errors.cursosOtros && <p style={{color: 'red'}}>Digite campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label>Necesidades en capacitaci&oacute;n empresarial</label>
                                            <input {...register('necesidadCapEmpresarial')}  className="form-control" placeholder=""/>
                                            {errors.necesidadCapEmpresarial && <p style={{color: 'red'}}>Digite campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label>Necesidades en capacitaci&oacute;n t&eacute;cnica</label>
                                            <input {...register('necesidadCapTecnica')}  className="form-control" placeholder=""/>
                                            {errors.necesidadCapTecnica && <p style={{color: 'red'}}>Digite campo</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <a className="btn btn-primary" onClick={AgregarFormacion}>Agregar</a>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card-body table-responsive p-0">
                                            <DataTable
                                                title="Formación"
                                                columns={columnsautonomiaformacion}
                                                data={getValues('AutonomiaFormacionSeleccionada')}    
                                                progressPending={Cargando}
                                                pagination
                                                noDataComponent="No hay datos para mostrar"
                                            /> 
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>Condiciones de la unidad de negocio</h3>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label>Cuenta con espacio y distribuci&oacute;n adecuada</label>
                                            <select {...register('cuentaEspacio', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="No Aplica">No Aplica</option>
                                            </select>
                                            {errors.cuentaEspacio && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label>Tiene RUT</label>
                                            <select {...register('tieneRut', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="No Aplica">No Aplica</option>
                                            </select>
                                            {errors.tieneRut && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label>Tiene manipulaci&oacute;n de alimentos</label>
                                            <select {...register('tieneManipuAlime', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="No Aplica">No Aplica</option>
                                            </select>
                                            {errors.tieneManipuAlime && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                <div className="col-md-4">
                                        <div className="form-group" >
                                            <label>Tiene bioseguridad</label>
                                            <select {...register('tieneBioseguridad', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="No Aplica">No Aplica</option>
                                            </select>
                                            {errors.tieneBioseguridad && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label>Tiene permiso de espacio publico</label>
                                            <select {...register('tienePermiEspPublico', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="No Aplica">No Aplica</option>
                                            </select>
                                            {errors.tienePermiEspPublico && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                        <label>	Total valor de activos</label>
                                            <input {...register('totalActivos')}  className="form-control" placeholder="0"/>
                                            {errors.totalActivos && <p style={{color: 'red'}}>Digite total</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                        <label>	Necesidades otros activos</label>
                                            <input {...register('necesidadesOtrosActivos')}  className="form-control" placeholder=""/>
                                            {errors.necesidadesOtrosActivos && <p style={{color: 'red'}}>Digite total</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>Aspectos de contables y financieros</h3>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label>Lleva registros contables</label>
                                            <select {...register('llevaRegContables', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.llevaRegContables && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                        <label>Promedio ventas mensuales</label>
                                            <input {...register('promVentasMensual')}  className="form-control" placeholder="0"/>
                                            {errors.promVentasMensual && <p style={{color: 'red'}}>Digite promedio</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                        <label>Promedio gastos totales mensuales (negocio)</label>
                                            <input {...register('promGastosTotalMen')}  className="form-control" placeholder="0"/>
                                            {errors.promGastosTotalMen && <p style={{color: 'red'}}>Digite total</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>En que invierte las ganancias</label>
                                            <select {...register('tipoInversionId', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {tiposInversion.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.tipTipoinversion}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.tipoInversionId && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label>Tiene o ha tenido cr&eacute;dito para su negocio</label>
                                            <select {...register('tieneCredito', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.tieneCredito && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                        <label>	Si tiene o ha tenido cr&eacute;dito, donde?</label>
                                            <input {...register('entidadCredito')}  className="form-control" placeholder="0"/>
                                            {errors.entidadCredito && <p style={{color: 'red'}}>Digite entidad</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Si no tiene cr&eacute;dito, porque</label>
                                            <select {...register('noTieneCreditoId', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {autonomiaNoTieneCredito.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.nombre}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.noTieneCreditoId && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>Aspectos de producci&oacute;n y mercadeo</h3>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Tiene adecuado manejo productivo</label>
                                            <select {...register('manejoAdecuadoProduc', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.manejoAdecuadoProduc && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Maneja criterios t&eacute;nicos de producci&oacute;n</label>
                                            <select {...register('criterioTecnicoProd', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.criterioTecnicoProd && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Maneja criterios de calidad</label>
                                            <select {...register('criterioCalidad', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.criterioCalidad && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Identifica y realiza correctivos a problemas del proceso productivo</label>
                                            <select {...register('correctivosProblema', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.correctivosProblema && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Tiene f&aacute;cil acceso a sus proveedores</label>
                                            <select {...register('facilAccesoProveedores', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.facilAccesoProveedores && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Se ha diversificado o mejorado sus productos</label>
                                            <select {...register('diversificadoProductos', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.criterioTecnicoProd && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Quiere implementar nuevos productos</label>
                                            <select {...register('quiereImpleNuevoProd', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.quiereImpleNuevoProd && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>	Conoce las caracter&iacute;sticas de su clientela</label>
                                            <select {...register('conoceCaracClientela', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.conoceCaracClientela && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Conoce las caracter&iacute;sticas de su competencia</label>
                                            <select {...register('conoceCaracCompetencia', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.conoceCaracCompetencia && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>An&aacute;lisis profesional</h3>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Horario capacitaci&oacute;n</label>
                                            <select {...register('horarioCapacitacionId', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {autonomiaHorarioCapacitacion.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.horHorariocapacitacion}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.horarioCapacitacionId && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label>Contin&uacute;a en proceso AE</label>
                                            <select {...register('continuaProceso', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.continuaProceso && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="porqueNoContinuaProceso">Raz&oacute;n porque no contini&uacute;a en proceso AE</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('porqueNoContinuaProceso', { required: true })}
                                                placeholder="Razon"
                                            />
                                            {errors.porqueNoContinuaProceso && <p style={{color: 'red'}}>Favor digite Observaciones</p>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* /.card-body */}
                            </div>
                            
                            <div className="card-footer">
                                <button type="submit" className="btn btn-info">Guardar</button>
                                
                            </div>
                            {/* /.card-footer */}
                        </form>
                        </div>
                        {/* /.card */}

                    </div>
                    {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}